<div class="distributionChannelWrapper">
    @if (isDisplayIcon && iconUrl) {
        <div class="logo-container">
            <img class="logo" [alt]="displayValue" [src]="cachedLogoUrl" />
        </div>
    }
    @if (displayValue) {
        @if (linkUrl) {
            <a [routerLink]="linkUrl" class="listingsTableLink">
                <span>{{ displayValue }}</span>
            </a>
        } @else {
            <span>{{ displayValue }}</span>
        }
    }
</div>
